/**
 * Resources listing: one product accordion open at a time.
 */
function setItemOpen(item, open) {
    const trigger = item.querySelector('.js-resources-trigger');
    const panel = item.querySelector('.resources__panel');

    if (!trigger || !panel) {
        return;
    }

    item.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
}

function initResourcesAccordion() {
    const root = document.querySelector('.resources');

    if (!root) {
        return;
    }

    root.addEventListener('click', (event) => {
        const trigger = event.target.closest('.js-resources-trigger');

        if (!trigger || !root.contains(trigger)) {
            return;
        }

        const item = trigger.closest('.js-resources-item');

        if (!item) {
            return;
        }

        const willOpen = trigger.getAttribute('aria-expanded') !== 'true';

        root.querySelectorAll('.js-resources-item.is-open').forEach((openItem) => {
            if (openItem !== item) {
                setItemOpen(openItem, false);
            }
        });

        setItemOpen(item, willOpen);
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initResourcesAccordion);
} else {
    initResourcesAccordion();
}
